import React from "react";
import Hero from "./Components/Hero";
import ConnectSlide from "./Components/ConnectSlide";
import Impact from "./Components/Impact";
import ImpactSlider from "./Components/ImpactSlider";
import GetInvolved from "./Components/GetInvolved";
import NewsSection from "./Components/NewsSection";
import FaqCom from "./Components/FaqCom";
import SEO from "../SEO";
import { useEffect } from "react";
import ReactGA  from "react-ga4";

const Home = () => {
	useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/",
      title: "Landing Page",
    });
  });
	return (
		<div>
			<SEO
				title='SynergyCare Foundation'
				description='Making Healthcare Accessible for All'
				name='SynergyCare Foundation'
				type=''
			/>
			<Hero />
			<ConnectSlide />
			<Impact />
			<ImpactSlider />
			<GetInvolved />

			<FaqCom />
			<NewsSection />
		</div>
	);
};

export default Home;
